import {
    IFetchDataStrategy,
    StoreLocatorFetchDataStrategy
} from '../strategies/StoresFetchDataStrategies';
import { IStoresCoordinates } from '~interfaces/IStoresInterfaces';

export class NearbyStoresLoadedUseCase {
    private coords: IStoresCoordinates;
    private fetchDataStrategy: IFetchDataStrategy;

    constructor(
        coords: IStoresCoordinates,
        fetchDataStrategy: IFetchDataStrategy = new StoreLocatorFetchDataStrategy()
    ) {
        this.coords = coords;
        this.fetchDataStrategy = fetchDataStrategy;
    }

    public execute = async () => {
        await this.fetchDataStrategy.loadStores(this.coords);
    };
}
